import { workoutsApi } from "~/store/initializeStore";

/**
 * Asks workouts-service to fan a challenge's recording workouts out to its cohort (TRE-2323). The server
 * reads the participants and event dates itself and authorizes on managing the challenge, not on
 * programs.manage over every trainee, so the cohort size and the caller's trainee scope no longer matter.
 */
export const scheduleChallengeRecordingWorkouts = async (params: {
  challengeId: string;
  /** Only this recording task; every recording task of the challenge when omitted. */
  taskId?: string;
  /** Only these trainees; every active participant when omitted. */
  traineeIds?: string[];
}): Promise<void> => {
  await workoutsApi.post("/schedule-challenge-recording-workouts", params);
};
